import { Outlet, useLocation } from "react-router-dom";
import { Wifi } from "lucide-react";

export function ClientLayout() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-stretch bg-gradient-to-br from-[#eef2f7] to-[#dde4ee] py-0 sm:items-center sm:py-10">
      {/* Подпись на десктопе */}
      <div className="hidden text-center sm:mb-6 sm:block">
        <div className="text-[12px] font-medium uppercase tracking-[0.08em] text-[var(--color-fg-muted)]">
          Android-клиент · АстраМаркет
        </div>
        <div className="mt-0.5 font-mono text-[10.5px] text-[var(--color-fg-faint)]">
          {location.pathname}
        </div>
      </div>

      <PhoneFrame>
        <Outlet />
      </PhoneFrame>
    </div>
  );
}

function PhoneFrame({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-full sm:w-[380px]">
      {/* Внешняя рамка устройства — видна только на ≥sm */}
      <div className="hidden sm:block">
        <div className="relative rounded-[42px] border border-[#bcc6d6] bg-[#1f2937] p-3 shadow-[0_30px_60px_-20px_rgba(15,23,42,0.35)]">
          <PhoneScreen>{children}</PhoneScreen>
          <div className="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-32 -translate-x-1/2 translate-y-[210px] rounded-full bg-[var(--color-surface)]/40" />
        </div>
      </div>

      {/* На мобиле — полноэкранный режим */}
      <div className="block sm:hidden">
        <PhoneScreen fullscreen>{children}</PhoneScreen>
      </div>
    </div>
  );
}

export function PhoneScreen({
  children,
  fullscreen = false,
}: {
  children: React.ReactNode;
  fullscreen?: boolean;
}) {
  return (
    <div
      className={
        "relative flex flex-col overflow-hidden bg-[var(--color-surface)] " +
        (fullscreen
          ? "min-h-screen w-full"
          : "h-[760px] w-full rounded-[30px]")
      }
    >
      <StatusBar />
      <div className="relative flex-1 overflow-hidden">{children}</div>
    </div>
  );
}

function StatusBar() {
  return (
    <div className="flex items-center justify-between px-5 pb-2 pt-3 text-[12px] font-medium text-[var(--color-fg)]">
      <span>9:41</span>
      <div className="flex items-center gap-1.5 text-[var(--color-fg-muted)]">
        <Wifi size={13} />
        <span>96%</span>
      </div>
    </div>
  );
}
